import {StyleSheet, Text, View, StatusBar, Image, ScrollView} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import {RFValue} from "react-native-responsive-fontsize";
import axios from "axios";
import React from "react";
import {useFocusEffect} from "@react-navigation/native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Config from "../../components/Config";



const  Hometab =({navigation})=> {

    let [crypos,setCrypros] = React.useState([]);




    // https://sourcearena.ir/api/?token=09b6c61f7108ed5017e5db5adb90500e&crypto_v2=all





    useFocusEffect(
        React.useCallback(() => {
            getCrypto2();
            getCrypto();
        }, [])
    );


    // React.useEffect(()=>{
    //     getCrypto();
    // },[])


    let [profile,setProfile] = React.useState({
        reward : '0' ,
        walletAmount : '0',
        totalreward : '0',
        full_name : 'Loading ... '
    });



    const getCrypto2 = async ()=>{



        let token = await AsyncStorage.getItem('token');
        let ress = await axios.get(
            `${Config.base}/api/v1/profile`,
            { params:
                    {
                        token: token
                    }
            }
        );





        profile = ress.data;
        setProfile(ress.data);






    }



    const getCrypto = async ()=>{

        let res = await axios.get(
            `${Config.base}/api/v1/listAllCrypto`
        );


        if(res.data){

            console.log(res.data.length);
            crypos = res.data;
            setCrypros(res.data)
        }


    }

    return (

        <>
            <LinearGradient
                // Background Linear Gradient
                colors={['#19222f', '#03685f']}
                // colors={['#662D8C', '#ED1E79']}
                // start={{ x: 0.0, y: 0.0 }}
                // end={{ x: 1, y: 1 }}
                style={styles.background}
            >
                <Image
                    resizeMode={'stretch'}
                    fadeDuration={999}
                    style={{
                        width : RFValue(190),
                        height :RFValue(30),
                        marginVertical : RFValue(30),
                        borderRadius : 15,
                    }}
                    // source={require('./../../assets/lc.png')}
                    // source={require('./../../assets/logo.png')}
                    source={{uri : 'https://metamax.network/frontAssets/assets/images/logo/logo-dark.png'}}
                />
                <View style={styles.header}>
                    <View style={styles.headerbox}>
                        <Text style={styles.headert1}>Wallet</Text>
                        <Text style={styles.headert3}>{profile.walletAmount}</Text>
                    </View>
                    <View style={styles.headerbox}>
                        <Text style={styles.headert2}>Rewards</Text>
                        <Text style={styles.headert4}>{profile.totalreward}</Text>
                    </View>
                </View>
                <View style={styles.border}></View>
                <Image
                    resizeMode={'stretch'}
                    fadeDuration={999}
                    style={{
                        width : '95%',
                        height :RFValue(125),
                        marginVertical : 10,
                        borderRadius : 15,
                        objectFit : 'cover'
                    }}
                    source={{uri : 'https://metamax.network/public/bannerHome.jpg'}}
                />
            </LinearGradient>
            <ScrollView style={styles.container}>

                {crypos.length > 0 &&
                    <View style={styles.box}>
                        <View style={styles.boxheader}>
                            <Text style={styles.boxtext}>Coin</Text>
                            <Text style={styles.boxtext}>24H Change</Text>
                            <Text style={styles.boxtext}>Price(USD)</Text>
                        </View>
                        {crypos.map((item,index)=>
                            <View key={index} style={styles.row}>
                                <Text style={styles.textrow}>
                                    <Image
                                        resizeMode={'stretch'}
                                        fadeDuration={999}
                                        style={{
                                            width : 15,
                                            height :15,
                                            marginRight : 10

                                            // borderRadius : 100,
                                        }}
                                        source={{uri : item.icon}}
                                    />
                                    {item.symbol}
                                </Text>
                                <Text style={styles.textrow}>{item.change_percent_24h} %</Text>
                                <Text style={styles.textrow}>{item.price}(USD)</Text>
                            </View>
                        )}
                    </View>

                }




            </ScrollView>
        </>



    );
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#03685f',
        // alignItems: 'center',
        // justifyContent: 'center',
    },
    background : {
        // flex : 1,
        // height : 215,
        // justifyContent : "center",
        alignItems:'center',
        // borderBottomEndRadius : 25,
        // borderBottomRightRadius : 25,
        // borderBottomLeftRadius : 25,
        // borderBottomWidth : 10,
        // borderBottomColor : 'red'
    },
    header : {
        justifyContent : 'center',
        alignItems : 'flex-start',
        flexDirection : 'row',
        // flex : 1,
        // backgroundColor : 'green'
    },
    headerbox : {
        // backgroundColor : 'red',
        padding : 12,
        width : '50%',
        // height : 110,
    },
    headert1:{
        color : '#FFF',
        fontSize : RFValue(17),
        fontFamily : 'novaria',

    },
    headert2:{
        color : '#FFF',

        fontSize : RFValue(17),
        fontFamily : 'novaria',

        textAlign : 'right'
    },
    headert3:{
        color : '#fff900',

        marginTop : 5,
        textAlign : 'left',

        fontSize : RFValue(15),
        fontFamily : 'novaria',
    },
    headert4:{
        color : '#fff900',

        marginTop : 5,
        textAlign : 'right',

        fontSize : RFValue(15),
        fontFamily : 'novaria',
    },
    border : {
        borderBottomColor : '#FFF',
        borderBottomWidth :1,
        width : '95%',
    },
    box : {
        width : '95%',
        backgroundColor : '#098f83',
        marginLeft : '2.5%',
        marginTop : 10,
        borderRadius : 10,
        padding:15
    },
    boxheader : {
        flexDirection  :'row',
        justifyContent : 'space-between',
        borderBottomColor : '#07bdad',
        paddingBottom : 10,
        borderBottomWidth:1
    },
    row : {
        flexDirection  :'row',
        justifyContent : 'space-between',
        alignItems : "center",
        paddingVertical : 10
    },

    boxtext : {

        color : '#f6f6f6',
        fontSize : RFValue(12),
        fontFamily : 'novaria',
        textAlign : "center"
    },
    textrow : {

        textAlign : "center",
        color : '#e1e1e1',
        fontSize : RFValue(11),
        fontFamily : 'novaria',
    }

});

export default Hometab;
